import { render, staticRenderFns } from "./ListPagination.vue?vue&type=template&id=1c7b8f12&scoped=true&"
import script from "./ListPagination.vue?vue&type=script&lang=ts&"
export * from "./ListPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7b8f12",
  null
  
)

export default component.exports